import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-alert-comment-modal',
  standalone:false,
  templateUrl: './alert-comment-modal.component.html',
  styleUrl: './alert-comment-modal.component.scss'
})
export class AlertCommentModalComponent {
  comment: string = '';
  constructor(
    public dialogRef: MatDialogRef<AlertCommentModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  close() {
    this.dialogRef.close();
  }

  submit() {
    this.dialogRef.close(this.comment);
  }

}
